import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import LEDTable from 'components/Products/IN-Motion/500/Dual_Sensor/LEDTable';
import NavButtons from 'components/Products/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  LEDTable,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};